import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { InventoryOutputDetailModel } from 'src/app/models/inventory/inventory-output-detail.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SubrentalOutputDetailCaptureTableModel } from 'src/app/models/tables/subrental/subrental-output-detail-capture-table.model';
import { SubrentalOutputDetailService } from 'src/app/services/subrental/subrental-output-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-subrental-output-detail',
  templateUrl: './subrental-output-detail.component.html',
  styleUrls: ['./subrental-output-detail.component.scss'],
  standalone: false
})
export class SubrentalOutputDetailComponent implements OnInit {
  @ViewChild('importDetail') importDetailModalComponent?: CustomModalComponent | null = null;

  @Input('subrentalOutputModel')
  set changeSubrental(changeSubrental: InventoryOutputModel) {
    this.changeSubrentalOutput(changeSubrental);
  }
  @Input('disabledActions')
  set changeDisable(disable: boolean) {
    this.tableActions = disable ? [] : this.getDefaultActions();
    this.disabledButton = disable;
  }
  @Input() listBranches: any[] = [];
  @Input() quantityDetails: number = 0;
  @Input() disabledDetail: boolean = false;
  @Input() userAuthenticated: UserModel = new UserModel();
  @Input() permissionsUser: OptionWindowModel[] = [];
  @Input() permissionUpdatable: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  columnSort: string | null = null;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  detailData: PagedResponseModel<SubrentalOutputDetailCaptureTableModel> = new PagedResponseModel<SubrentalOutputDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  isFormView: boolean = false;
  limit: number = 10;
  subrentalOutputDetail: InventoryOutputDetailModel = new InventoryOutputDetailModel();
  page: number = 1;
  subrentalOutputModel: InventoryOutputModel = new InventoryOutputModel();
  tableActions: TableAction[] = [];

  constructor(private subrentalOutputDetailService: SubrentalOutputDetailService,
    private toastHandlerService: ToastHandlerService) {
  }

  async ngOnInit() {
    await this.getColumns();
  }


  changeSubrentalOutput(changeSubrental: InventoryOutputModel) {
    this.subrentalOutputModel = changeSubrental;
    this.isFormView = false;
    if (this.subrentalOutputModel.inventoryOutputId != 0) {
      this.clearSelectionTrigger++;
      this.getSubrentalOutputDetailsBySubrentalOutput();
      this.page = 1;
    } else {
      this.detailData = new PagedResponseModel<SubrentalOutputDetailCaptureTableModel>();
    }
  }

  async createNewDetail() {
    this.subrentalOutputDetail = new InventoryOutputDetailModel();
    this.getFormView(true);
  }

  async deleteSubrentalOutput(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el artículo?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.subrentalOutputDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast('success', 'El artículo del despiece fue eliminado exitosamente.', 'Atención');
        this.subrentalOutputDetail = new InventoryOutputDetailModel();
        this.clearSelectionTrigger++;
        this.getSubrentalOutputDetailsBySubrentalOutput();
      } catch (error) {
        console.error('Error al eliminar el artículo del despiece .', error);
      }
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.subrentalOutputDetailService.getColumnsForDetailCapture());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getSubrentalOutputDetailsBySubrentalOutput() {
    try {
      this.detailData = await firstValueFrom(this.subrentalOutputDetailService.getSubrentalOutputDetailsForCapture(this.subrentalOutputModel.inventoryOutputId, this.page, this.limit, this.columnSort, this.ascendant,));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al buscar los detalles de la salida de subalquiler.', error);
    }
  }

  async onAction(event: { action: string, item?: SubrentalOutputDetailCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.subrentalOutputDetailService.getSubrentalOutputDetailById(event.item!.id));
      if (response)
        this.subrentalOutputDetail = response;
      this.getFormView(true);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteSubrentalOutput(event.selectedItems);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getSubrentalOutputDetailsBySubrentalOutput();
  }
}
